export type WatchPartySession = {
  key: string
  videoId: string
  promptCommentIds: string[]
  startsAt: string
  endsAt: string
}

export const WATCH_PARTY_SESSIONS: WatchPartySession[] = [
  {
    key: 'runningout-2026-09-03',
    videoId: '2284',
    promptCommentIds: ['17971'],
    startsAt: '2026-09-03T10:00:00+09:00',
    endsAt: '2026-09-10T10:00:00+09:00',
  },
]

const isOpen = (session: WatchPartySession, now: number): boolean => {
  return now >= new Date(session.startsAt).getTime() && now < new Date(session.endsAt).getTime()
}

export const findWatchParty = (now: number, videoId?: string): WatchPartySession | null => {
  return (
    WATCH_PARTY_SESSIONS.find(
      (session) => (videoId === undefined || session.videoId === videoId) && isOpen(session, now),
    ) ?? null
  )
}

export const watchPartyHref = (videoId: string) => `/videos/${videoId}?selectedTab=watchParty`

const WATCH_PARTY_STORAGE_KEY = 'watch_party_skip'

export const WATCH_PARTY_RESET_PARAM = 'watch_party_reset'

export const getWatchPartyDismissedKey = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  return window.localStorage.getItem(WATCH_PARTY_STORAGE_KEY)
}

export const setWatchPartyDismissedKey = (key: string): void => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(WATCH_PARTY_STORAGE_KEY, key)
  }
}

export const clearWatchPartyDismissedKey = (): void => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(WATCH_PARTY_STORAGE_KEY)
  }
}
